import { Injectable } from '@angular/core';
import { SupabaseBaseHttpService } from '@examdojo/supabase';
import { from, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class StudentClassAssignmentHttpService extends SupabaseBaseHttpService<'class_assignments', 'classroom'> {
  readonly schema = 'classroom';
  readonly tableName = 'class_assignments';
  readonly viewName = 'student_class_assignments';

  fetchByClassId(classId: string) {
    return from(
      this.supabase.client
        .schema(this.schema)
        .from(this.viewName)
        .select('*')
        .eq('class_id', classId)
        .throwOnError()
        .then((response) => response.data!),
    );
  }

  fetchClassIdByAssignmentId(assignmentId: string): Observable<string | null> {
    return from(
      this.supabase.client
        .schema(this.schema)
        .from(this.tableName)
        .select('class_id')
        .eq('assignment_id', assignmentId)
        .limit(1)
        .maybeSingle()
        .throwOnError()
        .then((response) => response.data?.class_id ?? null),
    );
  }
}
